import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import getBaseUri from '../utils/getBaseUri'; // Import the base URI function
import { Transition } from '../components/Transition/Transition';


const Posts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(`${getBaseUri()}/wp-json/wp/v2/posts`); // Use base URI
                setPosts(response.data);
            } catch (error) {
                console.error('Error fetching posts:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) {
        return <p>Loading posts...</p>;
    }

    if (posts.length === 0) {
        return <p>No posts found.</p>;
    }

    return (
        <Transition  className="posts">
            <h1>Posts</h1>
            <ul>
                {posts.map(post => (
                    <li key={post.id}>
                        <h2 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                        <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
                        <Link to={`/post/${post.id}`}>Read More</Link>
                    </li>
                ))}
            </ul>
        </Transition>
    );
};

export default Posts;
